import React from 'react';
import { IonGrid, IonRow, IonCol, IonFooter, IonToolbar, IonButton } from '@ionic/react';
import { receiptOutline } from 'ionicons/icons';
import Page from '../../../components/core/Page';
import { Product } from '../../../models';
import ProductCard from './ProductCard';
import CartButton from './CartButton';
import IconButton from '../../../components/common/IconButton/IconButton';
import {Customer} from "../../../models";

interface Props {
    customer?: Customer|null;
    products: Product[];
    isFetching: boolean;
    hasFetched: boolean;
    cartCount: number;
    onAddToCart: (product: Product, learnerId: number | null) => void;
    doRefresh: (event: CustomEvent) => void;
    isEventsOnly?: boolean;
}

export const ShopPage: React.FC<Props> = ({
    customer,
    products,
    isFetching,
    hasFetched,
    cartCount,
    onAddToCart,
    doRefresh,
    isEventsOnly = false,
}) => {
    return (
        <Page
            title={isEventsOnly ? "Events" : "Shop"}
            showMenuButton={false}
            showBackButton={true}
            backRouterLink="/home"
            showLoading={isFetching && !hasFetched}
            doRefresh={doRefresh}
            topRightButton={
                <>
                    <IconButton icon={receiptOutline} routerLink="/orders" color="primary" slot="end" />
                    <CartButton count={cartCount} routerLink="/checkout" />
                </>
            }
            footer={
                <IonFooter>
                    <IonToolbar color="primary">
                        <IonButton
                            routerLink="/checkout"
                            expand="block"
                            fill="clear"
                        >
                            Go to Cart ({cartCount})
                        </IonButton>
                    </IonToolbar>
                </IonFooter>
            }
        >
            <IonGrid className="ion-no-padding">
                <IonRow>
                    {products.filter(product => !!product).map((product) => (
                        <IonCol size="12" sizeMd="6" key={product.productKey}>
                            <ProductCard
                                customer={customer}
                                product={product}
                                onAddToCart={onAddToCart}
                            />
                        </IonCol>
                    ))}
                </IonRow>
            </IonGrid>

            {products.length === 0 && hasFetched && (
                <div className="ion-text-center ion-padding">
                    <p>{isEventsOnly ? "No events available at the moment." : "No shop products available at the moment."}</p>
                </div>
            )}
        </Page>
    );
};
